import http from "./httpService";

const apiEndpoint = "/branch";

export function getBranches() {
  return http.get(apiEndpoint);
}
